import React from "react"
import PropTypes from "prop-types"
import { AgGridReact as Grid } from "ag-grid-react"
import styled from "styled-components"
import { DateRenderer, normalizeDate, PrimaryButton, WarningButton } from "../../../components"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import * as actions from "../irr-sample.actions"
import * as applicationActions from "../../../application.actions"

const Container = styled.div`
  width: 100%;
  height: 600px;
`

const PatientNameContainer = styled.div`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
`

const PatientIconContainer = styled.button`
border: none; 
background: transparent;
`

export class IrrSampleGrid extends React.PureComponent {
  api = null;
  columnApi = null;
  state = {
    type: {},
    columns: {
      viewPatient: {
        headerName: "Patient Name",
        field: "name",
        type: "patientNameColumn",
        cellRenderer: "patientNameRenderer"
      },
      birthDate: {
        headerName: "Patient DOB",
        field: "dateOfBirth",
        cellRenderer: "dateRenderer",
        width: 140
      },
      admitDate: {
        headerName: "Admit Date",
        //   show: this.props.show,
        field: "admitDate",
        cellRenderer: "dateRenderer",
        width: 140
      },
      facility: {
        headerName: "Facility",
        field: "facility",
      },
      medicaidId: {
        headerName: "Medicaid Id",
        field: "medicaidId",
        width: 135
      },
      q1: {
        headerName: "Q1",
        field: "q1",
        width: 60
      },
      q2: {
        headerName: "Q2",
        field: "q2",
        width: 60
      },
      q3: {
        headerName: "Q3",
        field: "q3",
        width: 60
      },
      q4: {
        headerName: "Q4",
        field: "q4",
        width: 60
      },
      q5: {
        headerName: "Q5",
        field: "q5",
        width: 60
      },
      actions: {
        headerName: "Actions",
        roles: this.props.roles,
        type: "actionsColumn",
        cellRenderer: "actionsRenderer",
        width: 120
      },
    },
  };

  componentWillReceiveProps(nextProps) {
    if (this.api && this.props.data !== nextProps.data) {
      this.api.refreshCells();
    }

    if (this.api && this.columnApi && this.state.type !== nextProps.type) {
      const { type } = nextProps;
      this.setState({ type });
      if (type.mqd) {
        this.columnApi.setColumnVisible('q2', false);
        this.columnApi.setColumnVisible('q3', false);
        this.columnApi.setColumnVisible('q4', false);
        this.columnApi.setColumnVisible('q5', false);
        this.api.sizeColumnsToFit();
      }
    }
  }

  onGridReady = ({ api, columnApi }) => {
    this.api = api;
    this.columnApi = columnApi;
    api.sizeColumnsToFit();
    api.setFilterModel(this.props.gridFilterModel);
    api.setSortModel(this.props.gridSortModel);
    api.paginationGoToPage(this.props.currentPage);

  }

  onFilterChanged = ({ api }) =>
    this.props.actions.gridFilterChanged(api.getFilterModel());
  onSortChanged = ({ api }) =>
    this.props.actions.gridSortChanged(api.getSortModel());
  onPaginationChanged = ({ api }) =>
    this.props.actions.gridPaginationChanged(api.paginationGetCurrentPage());

  gridActions = (history) => ({ data }) => {
    return (
      <WarningButton onClick={() => history.push(`/records/${data.periodId}/${data.recordId}/irr/${data.sampleId}`)}>
        Review
      </WarningButton>
    )
  }

  viewPatientAction = (searchPatient) => ({ data }) => {
    return (
      <PatientNameContainer>
        <PatientIconContainer title="View Patient Details" onClick={() => searchPatient(data.name, normalizeDate(data.dateOfBirth))}>
          <i class="fa fa-user" style={{ color: "darkblue" }} aria-hidden="true" ></i>
        </PatientIconContainer>
        {data.name}
      </PatientNameContainer>
    )
  }

  render() {
    const { data } = this.props

    return (
      <Container className="ag-fresh">
        <Grid
          onPaginationChanged={this.onPaginationChanged}
          onFilterChanged={this.onFilterChanged}
          onSortChanged={this.onSortChanged}
          rowData={data}
          onGridReady={this.onGridReady}
          paginationPageSize={15}
          pagination={true}
          enableFilter={true}
          enableSorting={true}
          suppressMovableColumns={true}
          headerHeight={40}
          rowHeight={35}
          enableColResize={true}
          columnDefs={Object.values(this.state.columns)}
          defaultColDef={{ filterParams: { newRowsAction: "keep" } }}
          columnTypes={{
            actionsColumn: { suppressMenu: true, suppressSorting: true },
          }}
          frameworkComponents={{
            actionsRenderer: this.gridActions(this.props.history),
            patientNameRenderer: this.viewPatientAction(this.props.actions.searchPatient),
            dateRenderer: DateRenderer,
          }}
        />
      </Container>
    )
  }
}

IrrSampleGrid.propTypes = {
  data: PropTypes.array.isRequired,
  type: PropTypes.shape({
    hsag: PropTypes.bool.isRequired,
    mqd: PropTypes.bool.isRequired,
  }).isRequired,
  gridFilterModel: PropTypes.object,
  gridSortModel: PropTypes.array,
}

export default withRouter(
  connect(
    (state) => ({
      gridFilterModel: state.irrSample.grid.filterModel,
      gridSortModel: state.irrSample.grid.sortModel,
      currentPage: state.irrSample.grid.currentPage,
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        { ...applicationActions, ...actions },
        dispatch
      ),
    })
  )(IrrSampleGrid)
)



// WEBPACK FOOTER //
// ./src/modules/irr-sample/components/IrrSampleGrid.js